export default "__VITE_ASSET__ClwU9aVt__"